import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });
}

export const InstallAppButton = ({ className = "" }) => {
  const [hidden, setHidden] = useState(isStandalone());
  useEffect(() => {
    const done = () => setHidden(true);
    window.addEventListener("appinstalled", done);
    return () => window.removeEventListener("appinstalled", done);
  }, []);
  if (hidden) return null;
  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      deferred = null;
      if (outcome === "accepted") setHidden(true);
      return;
    }
    toast.info(isIOS()
      ? "No iPhone: toque em Compartilhar e depois em \"Adicionar à Tela de Início\"."
      : "Abra o menu do navegador (⋮) e toque em \"Instalar app\" ou \"Adicionar à tela inicial\".", { duration: 7000 });
  };
  return (
    <button type="button" onClick={install} data-testid="install-app-btn" className={`btn-red !px-4 !py-2 !text-xs ${className}`}>
      <Download className="h-4 w-4" /> Instalar app
    </button>
  );
};
